<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="overflow-hidden">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row v-if="mostrarBusquedas">
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchAll"
                append-icon="search"
                label="Búsqueda"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                outlined
                dense
                clearable
                v-model="selectedSucursal"
                :items="sucursalList"
                item-text="text"
                item-value="value"
                label="Filtrar por Sucursal"
                hide-details
                @change="filtrarPorSucursal"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                outlined
                dense
                clearable
                v-model="selectedSucursal"
                :items="sucursalList"
                item-text="text"
                item-value="value"
                label="Filtrar por Sucursal"
                hide-details
                @change="filtrarPorSucursal"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarBusqueda"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ mostrarBusquedas ? "search_off" : "search" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              mostrarBusquedas
                ? "Ocultar filtros de búsqueda"
                : "Mostrar filtros de búsqueda"
            }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarInactivos"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ !inactivos ? "visibility_off" : "visibility" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              inactivos ? "Ocultar Aprobados" : "Mostrar Aprobados"
            }}</span>
          </v-tooltip>
        </v-app-bar>

        <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 128 : 200)"
            :headers="headers"
            :items="dtTransferenciasFiltradas"
            :hide-default-header="isMobile"
            mobile-breakpoint="0"
            sort-by="codigo"
            :search="searchAll"
            class="elevation-1"
            :loading="dtDocumentosLoad"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template v-slot:[`item.estado`]="{ item }">
              <div v-if="item.estado == 'P'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="success"
                      x-small
                      text
                      dark
                      @click="abrirDialogAprobacion(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>fa-solid fa-circle-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aprobar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="error"
                      x-small
                      text
                      dark
                      @click="abrirDialogRechazo(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>fa-solid fa-circle-xmark</v-icon>
                    </v-btn>
                  </template>
                  <span>Rechazar</span>
                </v-tooltip>
              </div>


               
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">

                    <v-btn
                      color="warning"
                      x-small
                      text
                      dark
                      @click="marcarPendiente(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>fa-regular fa-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Marcar como Pendiente</span>
                </v-tooltip>
                
              </div>
               <div  :class="item.estado== 'P' ? 'font-weight-bold warning--text' : item.estado== 'A' ? 'font-weight-bold success--text' : 'font-weight-bold error--text'" >
                {{ item.estado== 'P' ? 'Pendiente' : item.estado== 'A' ? 'Aprobado' : 'Rechazado' }}
              </div>
              <div v-if="item.usuario_accion" class="text--secondary caption" >
                {{ 'por '+ item.usuario_accion }}
              </div>
            </template>

            <template v-slot:[`item.fecha`]="{ item }">
              <div>
                {{ $formatoFechaSpanish(item.fecha) }}
              </div>
            </template>

            <template v-slot:[`item.monto`]="{ item }">
              <div>
                {{ $formatoNumero(item.monto) }}
              </div>
              
            </template>

            <template v-slot:[`item.usuario`]="{ item }">
              {{ item.usuario }}
              
            </template>
            <template v-slot:[`item.cliente`]="{ item }">
              {{ '(' + item.codigo_cliente + ') ' + item.cliente }}
              
            </template>
            <template v-slot:[`item.imagen`]="{ item }">
              <div
                v-if="
                  !(
                    item.foto_comprobante === null ||
                    item.foto_comprobante === undefined ||
                    item.foto_comprobante === ''
                  )
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      v-img
                      :src="item.foto_comprobante"
                      style="
                        object-fit: fill;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        border: solid 1px #ccc;
                        }
                      "
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <span>{{
                    item.foto_comprobante === null ||
                    item.foto_comprobante === undefined ||
                    item.foto_comprobante === ""
                      ? "Cargar Imagen"
                      : "Ver Imagen"
                  }}</span>
                </v-tooltip>
              </div>
             
              
              
            </template>

            <template v-slot:no-data>
              <div>No se encontraron registros</div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>Aprobar Transferencia


            <div
                v-if="
                  !(
                    transferenciaObject.foto_comprobante === null ||
                    transferenciaObject.foto_comprobante === undefined ||
                    transferenciaObject.foto_comprobante === ''
                  )
                "
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <img
                      v-img
                      :src="transferenciaObject.foto_comprobante"
                      style="
                        object-fit: fill;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        border: solid 1px #ccc;
                        }
                      "
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <span>{{
                    transferenciaObject.foto_comprobante === null ||
                    transferenciaObject.foto_comprobante === undefined ||
                    transferenciaObject.foto_comprobante === ""
                      ? "Cargar Imagen"
                      : "Ver Imagen"
                  }}</span>
                </v-tooltip>
              </div>
            




          </v-card-title>
          <v-card-text
            >Digite el código de bancarización para aprobar la transferencia a: <p class="primary--text font-weight-black">{{ transferenciaObject.banco }}</p> 
            en fecha: <p class="primary--text font-weight-black">{{ $formatoFechaSpanish(transferenciaObject.fecha) }}</p> 
              por un monto de: <p class="primary--text font-weight-black">{{ $formatoNumero(transferenciaObject.monto) + ' ' + transferenciaObject.moneda  }}</p> 

            <v-text-field
              outlined
              color="icons"
              dense
              type="text"
              ref="bancarizacion"
              v-model="transferenciaObject.bancarizacion"
              
              :rules="[$rules.requerido]"
              :error-messages="errorMessages"
              label="Código de Bancarización"
              required
            ></v-text-field>
            <v-text-field
              outlined
              color="icons"
              dense
              type="text"
              ref="ordenante"
              v-model="transferenciaObject.ordenante"
              
              :rules="[$rules.requerido]"
              :error-messages="errorMessages"
              label="Ordenante"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>

            <div>
              <v-btn color="primary" text @click="aprobar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogBeta" persistent max-width="390">
        <v-card>
          <v-card-title>¿Está seguro?</v-card-title>
          <v-card-text
            >Esta acción rechazará la transferencia seleccionada.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogBeta = false">Cancelar</v-btn>
            <div>
              <v-btn color="primary" text @click="rechazar()">Continuar</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      //Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      //Declaración de arrays
      dtTransferencias: [],
      dtDocumentosLoad: true,
      areaList: [],
      subareaList: [],
      
      // Variables para filtro de sucursal
      sucursalList: [],
      selectedSucursal: null,

      //Declaración de variables de Dialog
      dialogBeta: false,
      dialogAlpha: false,
      dialogGamma: false,

      //Declaración de variables de formulario
     


      file: null,

      load: false,
      icono: "",
      color: "",

      //Declaración de variables de tabla

      selected: [2],

      headers: [
        {
          text: "Usuario",
          value: "usuario",
          align: "left",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Insertado por",
          value: "insertedBy",
          align: " d-none",
          
        },
        {
          text: "Sucursal",
          value: "sucursal",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Cliente",
          value: "cliente",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Razón Social",
          value: "razon_social",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Ordenante",
          value: "ordenante",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Banco",
          value: "banco",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Fecha",
          value: "fecha",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Monto",
          value: "monto",
          align: "right",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Imagen",
          value: "imagen",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Opciones",
          sortable: false,
          value: "estado",
          width: "1%",
          align: "center",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],

      searchAll: this.$route.query.numero,
      transferenciaObject: {},
      esEditado: false,
      editarCodigo: false,

      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      mostrarBusquedas: false,
      //variables de errrores
      valida: 0,
      errorMessages: "",
     
      ordenante:"",

      error: "",
      //variables de tamaño de pantalla
      isMobile: false,

      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        descripcion: this.descripcion,
      };
    },
    
    // Computed property para datos filtrados
    dtTransferenciasFiltradas() {
      if (!this.selectedSucursal) {
        return this.dtTransferencias;
      }
      return this.dtTransferencias.filter(item => 
        item.sucursal === this.selectedSucursal
      );
    },
   
  },

  watch: {
    dialogBeta(val) {
      val || this.cerrar();
    },

    name() {
      this.errorMessages = "";
    },
    
    // Watcher para limpiar filtro cuando cambie el estado de inactivos
    inactivos() {
      this.selectedSucursal = null;
    },
  },
  mounted() {
    window.addEventListener("resize", this.getDimensions);
  },
  unmounted() {
    window.removeEventListener("resize", this.getDimensions);
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("actualizarTitulo", "Transferencias");

    this.listar();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    getDimensions() {
      this.width = document.documentElement.clientWidth;
      this.height = document.documentElement.clientHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtDocumentosLoad = true;
      axios
        .get("api/valor_documentos/listarEstado/" + me.inactivos)
        .then(function (response) {
          me.dtTransferencias = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtDocumentosLoad = false;
          
          // Generar lista de sucursales únicas
          me.generarListaSucursales();
        })
        .catch(function (error) {
          me.dtDocumentosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listar();
    },

    // Método para generar lista de sucursales únicas
    generarListaSucursales() {
      const sucursalesUnicas = [...new Set(this.dtTransferencias.map(item => item.sucursal))];
      this.sucursalList = sucursalesUnicas
        .filter(sucursal => sucursal) // Filtrar valores nulos o undefined
        .sort()
        .map(sucursal => ({
          text: sucursal,
          value: sucursal
        }));
    },

    // Método para filtrar por sucursal
    filtrarPorSucursal() {
      // El filtrado se realiza automáticamente a través del computed property
      // Este método puede usarse para acciones adicionales si es necesario
    },

    abrirDialogAprobacion(item) {  
      this.transferenciaObject = item;      
      this.dialogAlpha = true;      
    },
    abrirDialogRechazo(item) {
      
      this.transferenciaObject = item;
      this.dialogBeta = true;
      
    },

    mostrarBusqueda() {
      this.mostrarBusquedas = !this.mostrarBusquedas;
      this.windowWidth = window.innerWidth;
      this.windowHeigth = window.innerHeight;
    },

    archivoCambiado(e) {
      this.selectedFile = e;
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },

    editar(item) {      
      this.transferenciaObject = item;

      this.transferenciaObject = item;

      this.esEditado = true;
      this.editarCodigo = false;
      this.dialogBeta = true;

      //debe agregarse $nextTick para los elementos no renderizados hastas su llamada
    },
    agregar() {
      this.editarCodigo = true;
      this.dialogBeta = true;
    },

    cerrar() {
      this.dialogBeta = false;
      this.limpiar();
    },

    limpiar() {
      this.transferenciaObject = {};

      this.esEditado = false;
      this.dialogBeta = false;
    },
    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarGenerico(obj) {
      this.valida = 0;

      Object.keys(obj).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    aprobar() {
      let me = this;

      if (me.transferenciaObject.bancarizacion === ""|| me.transferenciaObject.bancarizacion === null) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe llenar el código de bancarización.",
          color: "error",
        });
        return;
      }

      
      axios
        .put("api/valor_documentos/aprobar/" + me.transferenciaObject.id + "/" + me.transferenciaObject.bancarizacion + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: "Transferencia aprobada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    rechazar() {
      let me = this;
      axios
        .put("api/valor_documentos/rechazar/" + me.transferenciaObject.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
          me.dialogBeta = false;
          me.$store.dispatch("setSnackbar", {
            text: "Transferencia rechazada exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    marcarPendiente(item) {
      let me = this;
      axios
        .put("api/valor_documentos/pendiente/" + item.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listar();
         
          me.$store.dispatch("setSnackbar", {
            text: "Transferencia marcada como pendiente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    download(link, title) {
      var element = document.createElement("a");
      element.setAttribute("href", link);
      element.setAttribute("download", title);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
  },
};
</script>
